export default __webpack_public_path__ + "static/media/time-icon-blue.1c1bc08b.svg";